export default "__VITE_ASSET__Dpfs_Yvb__"